var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 3L60 54.8182H0L30 3ZM28.1847 38.191C28.2866 38.2597 28.4013 38.294 28.5287 38.294H31.9299C32.0573 38.294 32.1592 38.2597 32.2357 38.191C32.3376 38.0994 32.3885 37.9964 32.3885 37.882L32.9618 22.912C32.9618 22.7976 32.9108 22.706 32.8089 22.6373C32.7325 22.5458 32.6306 22.5 32.5032 22.5H28.0318C27.9045 22.5 27.7898 22.5458 27.6879 22.6373C27.6115 22.706 27.5732 22.7976 27.5732 22.912L28.0701 37.882C28.0701 37.9964 28.1083 38.0994 28.1847 38.191ZM27.8408 45.7446C28.4268 46.2482 29.1529 46.5 30.0191 46.5C30.8854 46.5 31.5987 46.2482 32.1592 45.7446C32.7197 45.2182 33 44.5658 33 43.7876C33 42.9864 32.7197 42.334 32.1592 41.8305C31.6242 41.3269 30.9108 41.0751 30.0191 41.0751C29.1274 41.0751 28.4013 41.3269 27.8408 41.8305C27.2803 42.334 27 42.9864 27 43.7876C27 44.5658 27.2803 45.2182 27.8408 45.7446Z",
    fill: "#FFE664"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/System.9b10d9ca715bae3986129f058c54e83f.svg";
export { ForwardRef as ReactComponent };